import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameMediaComponent } from './components/game-media/game-media.component';
import { GameMediaImagesComponent } from './components/game-media-images/game-media-images.component';
import { MediaDialogComponent } from './components/media-dialog/media-dialog.component';
import { MediaSelectionService } from './services/media-selection.service';
import { TournamentMediaComponent } from './components/tournament-media/tournament-media.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { GameMediaVideoComponent } from './components/game-media-video/game-media-video.component';
import { ButtonModule, DropdownModule, SvgIconModule, UtilsModule, ProgressModule, ShareModule } from '@mtgame/ui';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    DropdownModule,
    ButtonModule,
    SvgIconModule,
    UtilsModule,
    ProgressModule,
    ShareModule,
    SharedModule,
  ],
  providers: [
    MediaSelectionService,
  ],
  declarations: [
    TournamentMediaComponent,
    GameMediaComponent,
    GameMediaImagesComponent,
    MediaDialogComponent,
    GameMediaVideoComponent,
  ],
  exports: [
    TournamentMediaComponent,
    GameMediaComponent,
    GameMediaImagesComponent,
    MediaDialogComponent,
    GameMediaVideoComponent,
  ]
})
export class TournamentMediaModule {
}
